module.exports = __webpack_public_path__ + "static/media/C19.bb071194.png";